import { graphql } from '../../gql';

export const TALENT_DISCOVERY_BY_ID_V3 = graphql(`
  query TalentDiscoveryByIdV3($query: TalentDiscoveryByIdReqV3) {
    talent_discovery_search_by_id_v3(query: $query) {
      users {
        original_user_id
        user_id
        shard
        first_name
        last_name
        education
        user_location
        graduation_year
        work_history {
          first_name
          last_name
          email
          current_title
          current_company
          start_date
          end_date
          longitude
          latitude
          RCID
          gender
          ethnicity
          location
          highest_degree
          salary_base
          salary_total
          prestige
          remote_suitability
          years_of_experience
          flight_risk
          linkedin_url
          personal_email
          phone_number
          description
          skills
        }
        education_history {
          rsid
          start_date
          end_date
          title
          university_name
        }
      }
    }
  }
`);
